import { Inject, Injectable } from '@angular/core';
import { AppRootScope } from '@caslink/common-client';

/**
 * this is a temporary shim until the ThemeService in base caslink can be properly extracted,
 * so that only this implementation needs to be changed later
 */
@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    public static $name = 'devicesThemeService';

    constructor(
        @Inject('$rootScope') private $rootScope: AppRootScope
    ) {
    }

    public getTheme() {
        return this.$rootScope.currentTheme.name;
    }

    public getOpacityClass(opacity: number) {
        return `opacity-${opacity}`;
    }

    public getBackgroundPrimaryClassHue2() {
        return `background-${this.getTheme()}-primary-800`;
    }

    public getTextAccentClass() {
        return `text-${this.getTheme()}-accent`;
    }
}
